import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

export async function endEditMessage(groupId: string): Promise<boolean> {
  const inputPanel = Entities.InputPanelsStore.getById(groupId);
  if (inputPanel.editMessage) {
    const editText =
      inputPanel.editMessage.payload.text || inputPanel.editMessage.payload.comment || '';

    if (inputPanel.markdownValue !== editText) {
      const res = await Tasks.app.showConfirm({
        text: t('common_discard_changes_alert'),
        primaryText: t('common_yes'),
        secondaryText: t('common_no'),
      });
      if (!res) {
        return res;
      }
    }
  }

  if (inputPanel) {
    inputPanel.setEditMessageId(null);
    inputPanel.setValue(null);
  }

  return true;
}
